var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.974 0.750455C10.1299 0.745024 10.2836 0.788341 10.4137 0.874376C10.5439 0.960411 10.6439 1.08488 10.7 1.23045L13.015 7.25045H15V8.75045H12.5C12.3485 8.75051 12.2005 8.70468 12.0756 8.619C11.9506 8.53332 11.8545 8.4118 11.8 8.27046L10.079 3.79445L6.717 14.7215C6.67108 14.8706 6.57981 15.0017 6.45588 15.0965C6.33195 15.1912 6.18154 15.245 6.0256 15.2503C5.86966 15.2556 5.71596 15.2121 5.5859 15.1259C5.45584 15.0397 5.3559 14.9151 5.3 14.7695L2.985 8.75045H1V7.25045H3.5C3.65151 7.2504 3.79948 7.29623 3.92443 7.38191C4.04938 7.46759 4.14546 7.58911 4.2 7.73045L5.921 12.2065L9.283 1.27945C9.32887 1.13037 9.42008 0.999302 9.54393 0.904486C9.66778 0.80967 9.81811 0.755828 9.974 0.750455Z",
    fill: "#C4CAD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoot);
export default __webpack_public_path__ + "static/media/root.538a139ab21d8386aecf751f778fb001.svg";
export { ForwardRef as ReactComponent };